export const chillHop = () => {
  return [
    {
      name: 'Nectarine',
      cover: 'https://chillhop.com/wp-content/uploads/2022/10/2b9d337d372db542748e2643dc90af62dd3418e2-1024x1024.jpg',
      artist: 'Es-K, Danny James, John Culbreth',
      audio: 'https://mp3.chillhop.com/serve.php/?mp3=34242',
      color: ['#d7c9ae', '#b50105'],
      id: '1',
      active: true,
    },
    {
      name: 'Changing winds',
      cover: 'https://chillhop.com/wp-content/uploads/2022/06/312458b974ab45c795d75ec3f0259caa3989103a-1024x1024.jpg',
      artist: 'Knowmadic',
      audio: 'https://mp3.chillhop.com/serve.php/?mp3=41654',
      color: ['#fff3d3', '#d0666c'],
      id: '2',
      active: false,
    },
    {
      name: 'Seagulls',
      cover: 'https://chillhop.com/wp-content/uploads/2022/01/5753da482a6839b31e4905b22a2f8d65913e7eb4-300x300.jpg',
      artist: 'Misha, Zmeyev, Viktor Minsky',
      audio: 'https://mp3.chillhop.com/serve.php/?mp3=28936',
      color: ['#ffe0ca', '#7a0f33'],
      id: '3',
      active: false,
    },
    {
      name: 'Leaves Covered By Snow',
      cover: 'https://chillhop.com/wp-content/uploads/2020/07/4b06cedf68f3f842d3a0fc13ae62564dec6056c8-300x300.jpg',
      artist: 'No Spirit',
      audio: 'https://mp3.chillhop.com/serve.php/?mp3=8124',
      color: ['#dda0ae', '#ce6581'],
      id: '4',
      active: false,
    },
    {
      name: 'Chit Chat',
      cover: 'https://chillhop.com/wp-content/uploads/2021/07/5821e04fd52fa668a0b9890f213cbb12e454cc6b-1024x1024.jpg',
      artist: 'Middle School',
      audio: 'https://mp3.chillhop.com/serve.php/?mp3=22934',
      color: ['#a78d75', '#b65031'],
      id: '5',
      active: false,
    },
    {
      name: 'Everlight',
      cover: 'https://chillhop.com/wp-content/uploads/2021/11/4c9682ee612a3b8ef51de286c49b5489408e9257-300x300.jpg',
      artist: 'Parkbench Ephiphany',
      audio: 'https://mp3.chillhop.com/serve.php/?mp3=27501',
      color: ['#c0d2e1', '#e77c7a'],
      id: '6',
      active: false,
    },
    {
      name: 'Travelbag',
      cover: 'https://chillhop.com/wp-content/uploads/2021/05/1245c0271290a3196328c0cf4aaa910cd873dfe7-300x300.jpg',
      artist: 'Mommy, Sleepy Fish',
      audio: 'https://mp3.chillhop.com/serve.php/?mp3=19058',
      color: ['#c0d2e1', '#5a8dce'],
      id: '7',
      active: false,
    },
    {
      name: 'Apple Turnover',
      cover: 'https://chillhop.com/wp-content/uploads/2023/01/4a42f136486d42e4d021c673540885c82a1934e6-1024x1024.jpg',
      artist: 'Sleepy Fish, coa',
      audio: 'https://mp3.chillhop.com/serve.php/?mp3=37127',
      color: ['#eedeb8', '#e66e15'],
      id: '8',
      active: false,
    },
    {
      name: 'Sky Blue',
      cover: 'https://chillhop.com/wp-content/uploads/2020/06/faa452681fe33146c42a1b422fdf7cd7fd082637-1024x1024.jpg',
      artist: 'Matt Querentin',
      audio: 'https://mp3.chillhop.com/serve.php/?mp3=8615',
      color: ['#ba561e', '#754b59'],
      id: '9',
      active: false,
    },
    {
      name: 'Frisky Feeling',
      cover: 'https://chillhop.com/wp-content/uploads/2022/01/5753da482a6839b31e4905b22a2f8d65913e7eb4-300x300.jpg',
      artist: 'Ben Bada Boom',
      audio: 'https://mp3.chillhop.com/serve.php/?mp3=28955',
      color: ['#ffe0ca', '#7a0f33'],
      id: '10',
      active: false,
    },
    {
      name: 'Waybackwhen',
      cover: 'https://chillhop.com/wp-content/uploads/2021/11/4c9682ee612a3b8ef51de286c49b5489408e9257-300x300.jpg',
      artist: 'Philanthrope, Parkbench Ephiphany',
      audio: 'https://mp3.chillhop.com/serve.php/?mp3=27502',
      color: ['#c0d2e1', '#e77c7a'],
      id: '11',
      active: false,
    },
    {
      name: 'Sundials',
      cover: 'https://chillhop.com/wp-content/uploads/2022/07/49bc1653b33bd42e570ecdeba7be86e8bd1b5c38-1024x1024.jpg',
      artist: 'chief., Shrimpnose',
      audio: 'https://mp3.chillhop.com/serve.php/?mp3=36922',
      color: ['#f1d8e8', '#5d74a6'],
      id: '12',
      active: false,
    },
    {
      name: 'Blue',
      cover: 'https://chillhop.com/wp-content/uploads/2021/09/6a9ef8ac00e168d3308fdf9e336874c03fab829d-1024x1024.jpg',
      artist: 'Delayde, anybodyy',
      audio: 'https://mp3.chillhop.com/serve.php/?mp3=23195',
      color: ['#e6fcfc', '#419ea8'],
      id: '13',
      active: false,
    },
    {
      name: 'Blossom',
      cover: 'https://chillhop.com/wp-content/uploads/2022/01/5753da482a6839b31e4905b22a2f8d65913e7eb4-300x300.jpg',
      artist: 'Guillaume Muschalle, Makzo',
      audio: 'https://mp3.chillhop.com/serve.php/?mp3=28975',
      color: ['#ffe0ca', '#7a0f33'],
      id: '14',
      active: false,
    },
    {
      name: 'No more fires',
      cover: 'https://chillhop.com/wp-content/uploads/2020/07/4b06cedf68f3f842d3a0fc13ae62564dec6056c8-300x300.jpg',
      artist: 'Sleepy Fish',
      audio: 'https://mp3.chillhop.com/serve.php/?mp3=8445',
      color: ['#dda0ae', '#ce6581'],
      id: '15',
      active: false,
    },
    {
      name: 'Where We Met',
      cover: 'https://chillhop.com/wp-content/uploads/2020/06/faa452681fe33146c42a1b422fdf7cd7fd082637-1024x1024.jpg',
      artist: 'Xander, Carrick',
      audio: 'https://mp3.chillhop.com/serve.php/?mp3=9203',
      color: ['#ba561e', '#754b59'],
      id: '16',
      active: false,
    },
    {
      name: 'Treecko is a Cool Starter',
      cover: 'https://chillhop.com/wp-content/uploads/2023/01/4a42f136486d42e4d021c673540885c82a1934e6-1024x1024.jpg',
      artist: 'Sleepy Fish, coa',
      audio: 'https://mp3.chillhop.com/serve.php/?mp3=36922',
      color: ['#eedeb8', '#e66e15'],
      id: '17',
      active: false,
    },
    {
      name: 'Drift',
      cover: 'https://chillhop.com/wp-content/uploads/2022/01/d7c0bd347f56540babd9dd85454b93a89df84a15-300x300.jpg',
      artist: 'Somno',
      audio: 'https://mp3.chillhop.com/serve.php/?mp3=30133',
      color: ['#e99474', '#c54d4b'],
      id: '18',
      active: false,
    },
    {
      name: 'Condition Zero',
      cover: 'https://chillhop.com/wp-content/uploads/2022/01/5753da482a6839b31e4905b22a2f8d65913e7eb4-300x300.jpg',
      artist: 'HM Surf',
      audio: 'https://mp3.chillhop.com/serve.php/?mp3=30101',
      color: ['#ffe0ca', '#7a0f33'],
      id: '19',
      active: false,
    },
  ];
};

export const updateActiveSong = (allSongs, currentSong) => {
  const newSongs = allSongs.map((track) => {
    if (track.id === currentSong.id) {
      return {
        ...currentSong,
        active: true,
      };
    }

    return {
      ...track,
      active: false,
    };
  });

  return newSongs;
};

